import { inject, Injectable, signal, computed } from '@angular/core';
import { IBudget, IFinalBudget, IRemoteExperienceFromBudget, IRevisionFromBudget, IServicesFromBudget } from '@core/interface';
import { CalculateAdditionalServicesService } from './calculate-additional-services.service';

@Injectable({
  providedIn: 'root',
})
export class BudgetService {
  readonly #calculateDiscountService = inject(CalculateAdditionalServicesService);

  private readonly budgetSignal = signal<IFinalBudget>(
    {
      services: undefined,
      budget: {
        price: 0,
        applicableDiscount: 0,
        total: 0
      }
    });

  readonly computedBudget = computed(() => this.budgetSignal());

  // Building the budget
  // TODO: Calcular budget da experiência remota, mockei como se já estivesse formatado e calculado
  // TODO: Tipagem dos serviços quando não estiverem mais mockados
  calculate(
    additionalServices: any[],
    revision: any,
    remoteExperience: any,
    selectedDate: Date, 
    selectedHour: number): void {
    const services = additionalServices.length ? this.#calculateDiscountService.generateServicesFromBudget(
      additionalServices,
      selectedDate,
      selectedHour
    ) : undefined;

    const revisionBudget = {
      budget: {
        price: revision?.servicePrice || 0,
        applicableDiscount: revision?.discountPrice || 0,
        total: revision?.servicePrice || 0
      }
    }

    this.budgetSignal.set({
      services,
      revision: revisionBudget,
      remoteExperience,
      budget: this.#calculateTotal(services, revisionBudget, remoteExperience),
    });    
  }

  #calculateTotal(
    services?: IServicesFromBudget, 
    revision?: IRevisionFromBudget, 
    remoteExperience?: IRemoteExperienceFromBudget
  ): IBudget {
    
    let price = 0;
    let applicableDiscount = 0;
    let total = 0;

    if (services) {
      price += services.budget.price || 0;
      applicableDiscount += services.budget.applicableDiscount || 0;
      total += services.budget.total || 0;
    }

    // TODO: Isso é apenas um MOCK pra testar layout. Quando for implementar os cálculos de budget,
    // tratar da forma correta o preço e possíveis descontos na experiência remota e revisão.
    if (revision) {
      price += revision.budget.price || 0;
      applicableDiscount += revision.budget.applicableDiscount || 0;
      total += revision.budget.total || 0;
    }
    if(remoteExperience) {
      price += remoteExperience.budget.price || 0;
      applicableDiscount += remoteExperience.budget.applicableDiscount || 0;
      total += remoteExperience.budget.total || 0;
    }

    return {
      price,
      applicableDiscount,
      total,
    };
  }
}
